import { createAction } from 'redux-actions';

export const setEventId = createAction('SET_EVENT_ID');
export const resetNewEvent = createAction('RESET_NEW_EVENT');

export default {
  setEventId,
  resetNewEvent,
};
